module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-happy.cab34456.png";